import React from 'react';
import PropTypes from 'prop-types';
import { reduxFormPropTypes } from 'constants/propTypes';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import './RadioButton.scss';

function RadioButton(props) {
  const { input, meta, className, disabled, inline, children } = props;
  const { name, value } = input;
  const { form } = meta;
  const fieldName = `${form}.${name}.${value}`;

  return (
    <label htmlFor={fieldName} className={withMods('radio-button', { disabled, inline }, className)}>
      <span className={withMods('radio-button__label', { inline })}>{children}</span>
      <input
        {...input}
        type="radio"
        id={fieldName}
        disabled={disabled}
        className={withMods('radio-button__input', { disabled, inline })}
      />
    </label>
  );
}

RadioButton.propTypes = {
  ...reduxFormPropTypes.field,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default RadioButton;
